import { render } from "./InvoiceBeiblattTable.vue?vue&type=template&id=2dc49f50"
import script from "./InvoiceBeiblattTable.vue?vue&type=script&lang=js"
export * from "./InvoiceBeiblattTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__